import { Toaster as Sonner } from "sonner";

/**
 * Short confirmations and errors of asynchronous actions (design-system.md §5.2); announced politely. At the bottom
 * in the middle: the bars under a grid keep their buttons on the right, and a toast under the pointer does not leave.
 */
export function Toaster() {
  return (
    <Sonner
      position="bottom-center"
      toastOptions={{
        classNames: {
          toast: "rounded-lg border border-border bg-popover text-popover-foreground shadow-popover text-sm",
          description: "text-muted-foreground",
          actionButton: "bg-primary text-primary-foreground",
        },
      }}
    />
  );
}

export { toast } from "sonner";
